import { Box, Typography } from "@mui/material";
import { CheckOutlined, NotificationsOffOutlined } from "@mui/icons-material";
import { PolicyAction } from "~/operations";

export interface PolicyActionChipProps {
  action: PolicyAction;
  hideIcon?: boolean;
}

export function PolicyActionChip({ action, hideIcon }: PolicyActionChipProps) {
  const label = policyActionLabelMap[action];
  const color = policyActionColorMap[action];
  const Icon = policyActionIconMap[action];
  return (
    <Box
      className={`${label.toLowerCase()}-flag`}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 0.5,
        py: 0.5,
        px: 1,
        border: "1px solid",
        borderColor: color,
        borderRadius: 1,
        color,
      }}
    >
      {!hideIcon && <Icon sx={{ fontSize: 16 }} />}
      <Typography
        sx={{ fontSize: 12, fontWeight: 600, textTransform: "uppercase" }}
      >
        {label}
      </Typography>
    </Box>
  );
}

export const policyActionLabelMap = {
  [PolicyAction.Active]: "Scored",
  [PolicyAction.Ignore]: "Preview",
} as const;

export const policyActionColorMap = {
  [PolicyAction.Active]: "none.main",
  [PolicyAction.Ignore]: "text.disabled",
} as const;

export const policyActionIconMap = {
  [PolicyAction.Active]: CheckOutlined,
  [PolicyAction.Ignore]: NotificationsOffOutlined,
} as const;
